/**
 * @description Цена услуги в рублях.
 * @param {number} kop Копейки.
 * @constructor
 */
export default function ServicePriceRubles(kop) {
  /**
   * @description Добавить.
   * @param {ServicePriceRubles} candidate
   * @returns {ServicePriceRubles}
   */
  this.add = (candidate) => new this.constructor(kop + candidate.toKop());

  /**
   * @description Вычесть.
   * @param {ServicePriceRubles} candidate
   * @returns {ServicePriceRubles}
   */
  this.sub = (candidate) => new this.constructor(kop - candidate.toKop());

  /**
   * @description Умножить.
   * @param {number} value
   * @returns {ServicePriceRubles}
   */
  this.mul = (value) => new this.constructor(Math.floor(kop * value));

  /**
   * @description Разделить.
   * @param {number} value
   * @returns {ServicePriceRubles}
   */
  this.div = (value) => new this.constructor(Math.floor(kop / value));

  /**
   * @description К рублям.
   * @returns {number}
   */
  this.toRub = () => kop / 100;

  /**
   * @description Получить копейки.
   * @returns {number}
   */
  this.toKop = () => kop;

  /**
   * @description Меньше чем.
   * @param {ServicePriceRubles} candidate
   * @returns {boolean}
   */
  this.less = (candidate) => kop < candidate.toKop();

  const calcPercent = (percent) => Math.round((kop / 100) * percent);

  /**
   * @description Получить процент без округления.
   * @param {number} percent Процент.
   * @returns {ServicePriceRubles}
   */
  this.getPercentWithoutRound = (percent) => new this.constructor(calcPercent(percent));

  /**
   * @description Получить процент.
   * @param {number} percent Процент.
   * @returns {ServicePriceRubles}
   */
  this.getPercent = (percent) => new this.constructor(Math.round(calcPercent(percent) / 100) * 100);

  /**
   * @description Получить форматированное представление в рублях.
   * @param {string} currency Валюта.
   * @returns {string}
   */
  this.getFormattedRub = (currency = 'тнг') => {
    const parts = (kop / 100).toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (parts[1]) {
      parts[1] = parts[1].padEnd(2, 0).slice(0, 2);
    }
    return `${parts.join('.')} ${currency}`;
  };
}

ServicePriceRubles.zero = () => new ServicePriceRubles(0);
